/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { ApolloError } from "@apollo/client";
import { If, Then, Else } from "react-if";
import { Message } from "@nordcloud/gnui";

type SimpleError = {
  name: string;
  message: string;
};

type Props = {
  error?: ApolloError | Error | SimpleError;
  status?: "danger" | "notification";
  onClick?: () => void;
};

export function ErrorMessage({ error, status = "danger" }: Props) {
  const isReportingActive = false;
  const errorReportId = "";

  if (!error) {
    return null;
  }

  return (
    <Message status={status} image="danger">
      <p>
        <If condition={isReportingActive}>
          <Then>
            Sorry, something went wrong. Please try again or contact us using products@nordcloud.com.
            <br />
            Issue id: {errorReportId}
          </Then>
          <Else>{error.message}</Else>
        </If>
      </p>
    </Message>
  );
}
